/**
 * The query params the URL-backed states read and write.
 *
 * Declared here and nowhere else. `@kros-sk/shared/list` used to carry its own copy of the sort names
 * for `list-empty`, which read the URL directly; it reads the query states now, so nothing outside this
 * entry point names a query param.
 */
export const SORT_BY_QUERY_PARAM = 'sortBy';
export const SORT_DIRECTION_QUERY_PARAM = 'sortDirection';
export const FULLTEXT_QUERY_PARAM = 'fulltext';

/**
 * The modal a URL holds, and the prefix of each of its params: `?modal=invoice-detail&modal.id=42`. The URL-modals
 * engine in `@kros-sk/shared/modal-sheet` reads and writes them through `url-modal-query-params`, and a link to a
 * modal is built with `modalQueryParams`, so whoever links to a modal does not depend on the engine's library.
 */
export const URL_MODAL_QUERY_PARAM = 'modal';
export const URL_MODAL_PARAM_PREFIX = 'modal.';
